import React from 'react';
import PropTypes from 'prop-types';
import AnonFooter from './AnonFooter';
import AuthedFooter from './AuthedFooter';
import { FooterContext } from './SMFooterContext';

import './footer.scss';

const SMFooter = ({
  isUserAuthenticated,
  lang,
  domain,
  subdomain,
  country,
  variant,
  showBillingAddress,
  isEUDC,
  tld,
  url,
}) => {
  return (
    <FooterContext
      isUserAuthenticated={isUserAuthenticated}
      lang={lang}
      subdomain={subdomain}
      domain={domain}
      country={country}
      variant={variant}
      showBillingAddress={showBillingAddress}
      isEUDC={isEUDC}
      tld={tld}
      url={url}
    >
      <Choose>
        <When condition={isUserAuthenticated}>
          <AuthedFooter />
        </When>
        <Otherwise>
          <AnonFooter />
        </Otherwise>
      </Choose>
    </FooterContext>
  );
};

SMFooter.propTypes = {
  isUserAuthenticated: PropTypes.bool.isRequired,
  lang: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  subdomain: PropTypes.string.isRequired,
  showBillingAddress: PropTypes.bool,
  variant: PropTypes.string,
  isEUDC: PropTypes.bool.isRequired,
  tld: PropTypes.string.isRequired,
  url: PropTypes.string,
};

SMFooter.defaultProps = {
  showBillingAddress: false,
  variant: 'default',
  url: null,
};

export default SMFooter;
